import { useQuery } from '../use-query';
import { extendContainerValidator, toIsoDate } from '../../../utils';
import { containersService } from '../../../services';
import { useStoreTutorial } from '../../../context';
import { CONTAINER_MOCK_DATA } from '../../../const';

export const useContainersQuery = (keys: any = {}) => {
  const { tutorial } = useStoreTutorial();

  if (
    typeof keys.number === 'string' &&
    (keys.number?.length < 3 || !extendContainerValidator(keys.number))
  )
    delete keys.number;
  if (Array.isArray(keys.number)) {
    delete keys.take;
    delete keys.skip;
  }
  if (keys.startDate) keys.startDate = toIsoDate(keys.startDate, true);
  if (keys.endDate) keys.endDate = toIsoDate(keys.endDate, true);

  return useQuery(
    ['containers', JSON.stringify(keys), JSON.stringify(tutorial)],
    () => {
      if (tutorial.isActive) return Promise.resolve({ data: [CONTAINER_MOCK_DATA], totalCount: 1 });

      return containersService
        .getAll({
          params: keys,
        })
        .then((res) => res.data);
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};

export const useContainerQuery = (id = '') =>
  useQuery(
    ['container', id],
    () => {
      return containersService.get(id).then((res) => res.data.data);
    },
    {
      initialData: { data: {} },
    },
  );
